import React, { useEffect, useState } from 'react'
import CSSModules from 'react-css-modules'
import style from './index.module.scss'
import { Picker } from 'antd-mobile'
import { areaData } from './citys'
const pList = [
  "愛知県",
  "秋田県",
  "青森県",
  "千葉県",
  "愛媛県",
  "福井県",
  "福岡県",
  "福島県",
  "岐阜県",
  "群馬県",
  "広島県",
  "北海道",
  "兵庫県",
  "茨城県",
  "石川県",
  "岩手県",
  "香川県",
  "鹿児島県",
  "神奈川県",
  "高知県",
  "熊本県",
  "京都府",
  "三重県",
  "宮城県",
  "宮崎県",
  "長野県",
  "長崎県",
  "奈良県",
  "新潟県",
  "大分県",
  "岡山県",
  "沖縄県",
  "大阪府",
  "佐賀県",
  "埼玉県",
  "滋賀県",
  "島根県",
  "静岡県",
  "栃木県",
  "徳島県",
  "東京都",
  "鳥取県",
  "富山県",
  "和歌山県",
  "山形県",
  "山口県",
  "山梨県",
  "国外"
]
const AreaPicker = props => {
  const { className, style, onConfirm, onClose, selectedValue, visible, title = '', placeholder = '' } = props
  const [selectArea, setSelectArea] = useState(selectedValue || []) // 默认选中值
  const [initData, setInitData] = useState([])

  // 获取第三层数据（即区/县）
  const getCountyData = city => {
    const countyList = Object.entries(areaData.county_list) // 把县/区列表转换为键值对数组
    const dd = countyList
      .filter(([key]) => key.slice(0, 3) === city?.slice(0, 3)) // 过滤出当前城市的县/区
      .map(([key, value]) => ({
        label: value,
        value: key,
      }))
    return dd
  }

  // 获取第二层数据（即市/区）
  const getCityData = province => {
    const cityList = Object.entries(areaData.city_list) // 把城市列表转换为键值对数组
    const dd = cityList
      .filter(([key]) => key.slice(0, 3) === province?.slice(0, 3)) // 过滤出当前省份的城市
      .map(([key, value]) => ({
        label: value,
        value: key,
        children: getCountyData(province), // 获取当前城市的县/区数据
      }))
    return dd
  }

  // 获取级联选择器数据
  const getCascadeData = () => {
    const provinceList = Object.entries(pList) // 把省份列表转换为键值对数组
    console.log(pList)
    const result = pList.map((item) => {
      console.log(item)
      return {
        label: item,
        value: item,
        // children: getCityData(provinceCode), // 获取当前省份的城市数据
      }
    })
    console.log(result)
    return result
  }

  // 获取省
  const getProvince = code => {
    const val = areaData.province_list[`${code}`]
    return val
  }

  // 获取市
  const getCity = code => {
    const val = areaData.city_list[`${code}`]
    return val
  }

  // 获取区
  const getCounty = code => {
    const val = areaData.county_list[`${code}`]
    return val
  }

  // 每次选择时更新选中值
  const handleChange = value => {
    // console.log('handleChange')
    setSelectArea(value)
  }

  const handleClose = () => {
    setSelectArea(['', '', ''])
    onClose && onClose()
  }

  // 确认选择并触发回调
  const handleConfirm = val => {
    console.log(val)
    const res = {
      province: val[0],
      city: getCity(val[1]),
      district: getCounty(val[2]),
    }
    // console.log('handleConfirm', val, res)
    onConfirm && onConfirm(res)
    setSelectArea(['', '', ''])
  }

  useEffect(() => {
    // console.log('getCascadeData======', getCascadeData())
    setInitData([getCascadeData()])
  }, [])

  return (
    <div {...{ className, style }}
        styleName="picker-box">
      {initData.length > 0 && <Picker
          onClose={handleClose}
          onConfirm={handleConfirm}
          onSelect={handleChange}
          columns={initData}
          placeholder={placeholder}
          title={title}
          value={selectArea}
          visible={visible}></Picker>}
    </div>
  )
}

export default CSSModules(AreaPicker, style)
